import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { FileUploaderComponentModule } from '@adaptiva/widgets/file-uploader';
import { ImageComponentModule } from '@adaptiva/widgets/image';
import { ObjectListModule } from '@adaptiva/widgets/object-list';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { IconPropertiesComponent } from './icon-properties.component';

const WIDGETS = [
	AuthoringPropertyLabelComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	FileUploaderComponentModule,
	ImageComponentModule,
	ObjectListModule,
	TextComponentModule,
];

const PIPES = [
	DisplayAuthoringPropertyPipe,
	IsRequiredPropertyPipe,
	InheritPipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [IconPropertiesComponent],
	exports: [IconPropertiesComponent]
})
export class IconPropertiesComponentModule {

}
